import dayjs from "dayjs";
import {CYCLE, MESSAGE_TYPE} from "../../shared/utils/enum";
import {EntityBase} from "../../shared/entity/EntityBase";

const MESSAGE_FIELDS = {
    id: { type: parseInt, defaultValue: 0 },
    sendTime: { defaultValue: dayjs().format('YYYY-MM-DD HH:mm:ss') },
    messageType: { type: Number, defaultValue: MESSAGE_TYPE.IMMEDIATE },
    topic: { defaultValue: [] },
    body: { defaultValue: [] },
    memo: { defaultValue: '' },
    state: { type: Number, defaultValue: 0 },
    timeType: { type: Number, defaultValue: CYCLE.MINUTE },
    repeatTime: { type: Number, defaultValue: 0 },
    end: { defaultValue: dayjs().format('YYYY-MM-DD HH:mm:ss') },
}

export class MessageEntity extends EntityBase {
    constructor(data = {}) {
        super(data, MESSAGE_FIELDS);

        this.errors = [
            { condition: () => this.topic.length === 0, message: '메시지 토픽이 없습니다.' },
            { condition: () => this.body.length === 0, message: '메시지 내용이 없습니다.' },
            { condition: () => this.body.some((push) => push.title === '' || push.body === ''), message: 'Title이나 Body를 확인해주세요.' },
        ];
    }
}